module.exports = __webpack_public_path__ + "img/consult_info4.c27183b7.png";